<div class="otp-form" *puLet="countdown$ | async as countdown">
  <div class="title pp-bold-16">
    {{ title() | translate }}
  </div>

  <div class="description pp-regular-12 pp-gray">
    <p>{{ 'signup.otp.text.size' | translate: { size: numberSize() } }}</p>
    <p>
      {{ 'signup.otp.text.sentTo' | translate
      }}<span class="pp-white">{{ sentTo() }}</span>
    </p>
  </div>

  <pu-otp-input
    [hasAutofocus]="hasAutofocus()"
    [formControl]="control()"
    [size]="numberSize()"></pu-otp-input>

  <div class="pp-regular-12 pp-gray">
    {{ 'signup.otp.countdown.text1' | translate }}
    @if (countdown > 0) {
      <span class="pp-white">
        {{ 'signup.otp.countdown.text2' | translate: { countdown } }}
      </span>
    } @else {
      <a
        href="javascript:void(0)"
        class="resend-link pp-white"
        (click)="resendCode()"
        >{{ 'signup.otp.countdown.resend' | translate }}</a
      >
    }
  </div>
</div>
